// Code 128 barcodes (N12 labels): the bar and space widths for a text, for any renderer (the label PDFs draw them with
// pdfkit). Code set C for an even run of digits (a UPC or EAN prints shorter and scans the same), else code set B
// (printable ASCII; anything else becomes "?"). No dependency: the 107 symbol patterns are the standard's table.
// Tests: server/test/labels.test.ts.

/** Each symbol's widths, bar first, in modules (11 each; the stop symbol 13). Index = symbol value. */
export const PATTERNS: readonly string[] = [
  "212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 122231",
  "113222 123122 123221 223211 221132 221231 213212 223112 312131 311222 321122 321221 312212 322112 322211",
  "212123 212321 232121 111323 131123 131321 112313 132113 132311 211313 231113 231311 112133 112331 132131",
  "113123 113321 133121 313121 211331 231131 213113 213311 213131 311123 311321 331121 312113 312311 332111",
  "314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 112412 122114 122411 142112 142211",
  "241211 221114 413111 241112 134111 111242 121142 121241 114212 124112 124211 411212 421112 421211 212141",
  "214121 412121 111143 111341 131141 114113 114311 411113 411311 113141 114131 311141 411131 211412 211214",
  "211232 2331112",
]
  .join(" ")
  .split(" ");
const START_B = 104;
const START_C = 105;
const STOP = 106;

/** The symbol values for a text, start and checksum included (not the stop). */
export function code128Values(text: string): number[] {
  const values: number[] = [];
  if (/^(\d\d)+$/.test(text) && text.length >= 4) {
    values.push(START_C);
    for (let i = 0; i < text.length; i += 2) values.push(Number(text.slice(i, i + 2)));
  } else {
    values.push(START_B);
    for (const ch of text) {
      const code = ch.charCodeAt(0);
      values.push(code >= 32 && code <= 126 ? code - 32 : 31); // "?"
    }
  }
  const check = values.reduce((sum, v, i) => sum + v * Math.max(1, i), 0) % 103;
  return [...values, check];
}

/** Bar and space widths in modules, bar first, with the stop: what a renderer draws (plus a quiet zone of 10 each side). */
export function code128(text: string): number[] {
  return [...code128Values(text), STOP].flatMap((v) => [...PATTERNS[v]].map(Number));
}
